import axios from 'axios';
import Vue from 'vue';
import Cookie from 'js-cookie';

axios.defaults.baseURL = process.env.VUE_APP_SEEKER_API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

if (typeof window?.overrideAfConfig == 'function') {
    window.overrideAfConfig();
}

if (process.env.NODE_ENV === 'production') {
    axios.defaults.headers.common['job-buckets'] = window?.afConfig?.job_buckets;
    axios.defaults.headers.common['platform-code'] = window?.afConfig?.platform_code;
    axios.defaults.headers.common['seeker-buckets'] = window?.afConfig?.seeker_buckets;
    axios.defaults.headers.common['site-code'] = window?.afConfig?.site_code;
} else {
    axios.defaults.headers.common['job-buckets'] = process.env.VUE_APP_LOCAL_JOB_BUCKET || 'AFDEVDEMO';
    axios.defaults.headers.common['platform-code'] = 'applyflow';
    axios.defaults.headers.common['seeker-buckets'] = process.env.VUE_APP_LOCAL_SEEKER_BUCKET || 'afdevdemo';
    axios.defaults.headers.common['site-code'] = process.env.VUE_APP_LOCAL_SITE_CODE || 'afdevdemo';
    window.afConfig = {
        site_code: process.env.VUE_APP_LOCAL_SITE_CODE || 'afdevdemo',
        show_company_logo: 'Yes',
        seek_advertiser_id: 1732,
        applyflow_custom_1_label: 'Work Type',
        applyflow_custom_1_show: 'Yes',
        applyflow_custom_2_label: 'Job Type',
        applyflow_custom_2_show: 'Yes',
        applyflow_custom_3_label: 'Contract Type',
        applyflow_custom_3_show: 'No',
        applyflow_custom_4_show: 'Yes',
        // hide_location_filter: 'Yes',
        // hide_salary_filter: 'Yes',
        show_company_filter: 'No',// eslint-disable-next-line
        show_country_locations_filter: 'No',
        terms_content: JSON.stringify([
            {
                id: 1,
                content: 'I agree to <a href="#">terms</a> and conditions.',
                display_checkbox: true,
                prechecked: true,
                required_field: true,
            },
            {
                id: 2,
                content: 'I agree to MVPQA <a href="#">terms</a> and conditions.',
                display_checkbox: true,
                prechecked: true,
                required_field: false,
            },
        ]),
        // locale: 'nl',
        // base_url_search_result_page: 'werken-bij/vacatures',
        // base_url_job_view_page: 'werken-bij/vacatures/job-details',
        show_site_logo_on_job_cards: 'yes',
        show_candidate_application_status: 'Yes',
        use_iframe_for_external_apply: 'Yes',
        use_iframe_for_external_apply_domain: '*.programmed.com.au, donot-apply.com',
        job_apply_resume_optional: 'Yes',
        jobs_list_map_enabled: 'Yes',
        job_details_map_enabled: 'Yes',
        jobs_list_map_link_target: '_blank',
        job_details_map_zoom: 5,

        candidate_info_deletion_options: 'Delete',
        candidate_self_delete_info: '<p>This will permanently delete your account and your personal data.</p<p><strong>Data that will be deleted includes:</strong></p><ul><li>Your personal information</li><li>Applications to jobs within our system (not data that an employer may have downloaded)</li><li>Resumes, including from the employer candidate search</li><li>Marketing and job alert email subscriptions</li></ul>You will be able to create a new account afterwards.',
        hide_job_view_button_on_candidate_dashboard: 'Yes',
        allow_job_reapply: 'Yes',
        job_reapply_limit: '',
        show_currency_code_only: 'No',
        screening_question_position: 'After job apply',
        show_currency_code_as_suffix: 'No',
    };
}
for (const method of ['request', 'delete', 'get', 'head', 'options', 'post', 'put', 'patch']) {
    axios['$' + method] = (...args) => {
        return axios[method].call(axios, ...args).then(res => res && res.data);
    };
}

axios.interceptors.request.use(config => {
    const token = Cookie.get(process.env.VUE_APP_COOKIE_TOKEN_NAME);

    if (token) {
        config.headers.common['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

Vue.$axios = axios;

Object.defineProperties(Vue.prototype, {
    $axios: {
        get() {
            return axios;
        },
    },
});
